import {Space} from "./Space";

export const Indent = () => {
    return <Space width="25px"/>
}